module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_baby-83e9ee0a5d5843bbf34310813dee5f96.png";